import { useParams } from 'react-router-dom';
import { BottomBar, MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { useFeatureFlags } from 'core/app/AppContext';
import { NotFoundPage } from 'core/ui/components/error';
import { EditRoleForm } from './components/EditRoleForm';
import { EditRoleSaveBar } from './components/EditRoleSaveBar';
import { EditRoleProvider } from './context/EditRoleProvider';

export function EditRolePage() {
  const { roleId } = useParams<{ roleId: string }>();
  const { flagEnabled } = useFeatureFlags();

  if (flagEnabled('role-management-ui')) {
    return (
      <EditRoleProvider roleId={roleId}>
        <MainArea>
          <TopArea>
            <AppTopBar />
          </TopArea>
          <Page>
            <EditRoleForm />
          </Page>
          <BottomBar>
            <EditRoleSaveBar />
          </BottomBar>
        </MainArea>
      </EditRoleProvider>
    );
  } else {
    return <NotFoundPage />;
  }
}
